import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { Config } from "../core/config/config";
import { Helper } from "../core/util/helper";
import React from "react"
export default class AssignToMe extends React.Component<any, any>{
    constructor(props) {
        super(props)
    }

    private onClick = () => {
        General.Sheet.Manager.getTopMostSheet().trigger(SheetEventType.Custom, {cmd: "assignToMe"})
    }

    render() {
        return (
            <div style={{ display: Helper.isNullOrEmpty(Config.user.ressNr) ? "none": "flex", flexDirection: "row-reverse", paddingTop: "3px" }}>
                <a onClick={this.onClick}>{Helper.getTranslation("WebSMS.Ticket.Assignment.AssignToMe")}</a>
            </div>
        );
    }
}